import React, { useMemo } from 'react';
import Modal from '@components/common/Modal';
import { CUSTOM_MESSAGES, LABEL } from '../../../veriables';
import style from '../OthersPopUpScreen/otherPopup.module.scss';
import cn from 'classnames';
import { TouchableButton, TouchableCross } from '@components/common/Touchable';

const ExistingCheckModal = props => {
  // Props Destructuring
  const {
    checkModelOpen,
    setCheckModelOpen,
    isTableValue,
    serverAppTheme,
    setIsOpenCheck,
    setIsModalOpen,
  } = props;

  const hideNewCheck =
    props.deviceInfo?.deviceGroup !== null &&
    props.deviceInfo.deviceGroup?.serverAppSettings
      ?.suppressMultipleChecksOnTable;

  // Methods
  const handleNewCheck = () => {
    props.submitTableNumber(isTableValue);
  };

  const handleGoToCheck = () => {
    const isTab =
      (isTableValue?.tabName !== undefined || isTableValue?.tabName !== null) &&
      isTableValue?.tabName?.length > 0;
    isTab
      ? props.goToOrder(
          Object.values(props.tableData).find(
            e =>
              e.open &&
              e.tab &&
              (e.stationName === isTableValue?.tabName ||
                e.stationNumber === isTableValue?.tabName)
          ),
          props.pageNo
        )
      : props.goToOrder(
          Object.values(props.tableData).find(
            e =>
              e.open &&
              !e.tab &&
              ((e.stationName &&
                e.stationName.toLowerCase() ===
                  isTableValue.tableNumber.toLowerCase()) ||
                (e.stationNumber &&
                  e.stationNumber.toLowerCase() ===
                    isTableValue.tableNumber.toLowerCase()))
          ),
          props.pageNo
        );
  };

  const popupStyles = useMemo(() => {
    const modal = {
      background: serverAppTheme ? serverAppTheme.popUp_bg : '#2F2F2F',
      border: serverAppTheme ? serverAppTheme.popupBorder : '1px solid #626262',
      borderRadius: '16px',
      boxShadow: serverAppTheme?.popUp_box_shadow,
    };
    const icon = {
      color: serverAppTheme ? serverAppTheme?.primary_text : 'white',
    };
    const newcheck = {
      backgroundColor: serverAppTheme?.OFF_Premise_Btn,
      border: serverAppTheme?.cancleBtn_Border,
      color: serverAppTheme?.cancleBtn_font,
    };
    const gotocheck = {
      backgroundColor: serverAppTheme?.secondaryBtn,
      color: serverAppTheme?.btn_font_color,
    };
    const cross = {
      top: '0.5rem',
      right: '0.5rem',
    };
    return { modal, icon, newcheck, gotocheck, cross };
  }, [serverAppTheme]);

  // HTML CSS CODE
  return (
    <Modal
      isOpen={checkModelOpen}
      isModalCenter
      noBackground
      customWidth
      customClass2="h-100 w-100 p-3 d-flex justify-content-center align-items-center my-0 mx-0"
      customClass="h-100 w-100"
      customClass3="w-90"
      style={popupStyles.modal}
    >
      <div
        className="col-12 px-0 pb-2 pt-3 justify-content-center align-items-center position-relative text-center"
        style={popupStyles.icon}
      >
        {/* ********************** <Replacing svg to UniCode by #Sarang/> ******************  */}
        <div className="row px-0 mx-0 pb-3">
          <div className="col-12 px-0 fs_18 fw-700 text-center d-flex align-items-center justify-content-center">
            Are You Sure ?
          </div>
          <div className="fs-18 position-absolute" style={popupStyles.cross}>
            <TouchableCross
              fill={serverAppTheme?.iconcolor}
              role="presentation"
              onClick={event => {
                event.preventDefault();
                setCheckModelOpen(false);
              }}
            />
          </div>
          {/* ******************************************************  */}
        </div>
        <div className="col-12 fs_14 fw-400 text-center pb-2">
          {CUSTOM_MESSAGES().OPEN_TABLE_CHECK_SAME_EMPLOYEE
            ? CUSTOM_MESSAGES().OPEN_TABLE_CHECK_SAME_EMPLOYEE
            : CUSTOM_MESSAGES().OPEN_TABLE_CHECK}
        </div>
        <div className="col-12 w-100 row mx-0 py-2 px-0 justify-content-center align-items-center text-center p-3">
          {!hideNewCheck && (
            <div className="col-4 pl-0 pr-2">
              <TouchableButton
                className={cn(style.Unselected_menu_btn, 'w-100 btn44 rounded')}
                style={popupStyles.newcheck}
                type="button"
                onClick={event => {
                  event.preventDefault();
                  setCheckModelOpen(false);
                  handleNewCheck();
                }}
                rippleEffect={true}
              >
                <div className="fs_18 fw-600">{LABEL().NEW_CHECK}</div>
              </TouchableButton>
            </div>
          )}
          <div className={cn('col-4 pl-0 pr-2')}>
            <TouchableButton
              className={cn(
                style.secondary_btn_color,
                'w-100 btn44 border-0 rounded'
              )}
              style={popupStyles.gotocheck}
              type="button"
              onClick={event => {
                event.preventDefault();
                setCheckModelOpen(false);
                handleGoToCheck();
              }}
              rippleEffect={true}
            >
              <div className="fs_18 fw-600">{LABEL().GO_TO_CHECK}</div>
            </TouchableButton>
          </div>
          <div className="col-4 pl-0 pr-0">
            <TouchableButton
              className={cn(style.Unselected_menu_btn, 'w-100 btn44 rounded')}
              style={popupStyles.newcheck}
              type="button"
              onClick={e => {
                e.preventDefault();
                setCheckModelOpen(false);

                if (
                  isTableValue?.tabName !== undefined &&
                  isTableValue?.tabName !== null
                ) {
                  setIsModalOpen(true);
                } else setIsOpenCheck(true);
              }}
              rippleEffect={true}
            >
              <div className="fs_18 fw-600">
                {isTableValue?.tabName !== undefined &&
                isTableValue?.tabName !== null
                  ? LABEL().SELECT_ANOTHER_TAB
                  : LABEL().SELECT_ANOTHER_TABLE}
              </div>
            </TouchableButton>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default React.memo(ExistingCheckModal);
